import { ATASList, ATASMap, DocAccessType } from '../../../../types';
import { Section } from '../../../Finger/Section';
import FingerWithApprove from '../../../atoms/finger-with-approve';
import { SummaryRow } from '../../../Summary/SummaryRow';
import NoDocuments from '../../../atoms/no-doc-placeholder';
import { getFingerStatus, getVisible, hasDeleted } from '../../../../utilities/documents';
import { UserRole } from '../../../../store/auth/types';

export interface IProps {
  infoOnly: boolean;
  userAccess?: DocAccessType;
  documents: ATASMap;
  warning?: string;
  userRole?: UserRole;
  canResume: boolean;
  canUpload: boolean;
  canOpen: boolean;
  canApprove: boolean;
  canReject: boolean;
  isDeleting: boolean;
  canAcknowledge: boolean;
  onResume: (url: string) => void;
  onUploadClick: (docKey: string) => void;
  onOpenClick: (docKey: string) => void;
  onApproveClick: (docKey: string) => void;
  onRejectClick: (docKey: string) => void;
  onRescindRejectClick: (docKey: string) => void;
  onDeleteClick: (docKey: string) => void;
  onAcknowledgeClick: (docKey: string) => void;
}

const ATASHand = (props: IProps) => {
  const { documents: docs, infoOnly, userAccess, userRole } = props;

  if (!docs || Object.keys(docs).length === 0) {
    return null;
  }

  const visibleDocs = getVisible({ documentsHash: docs, userAccess, infoOnly, userRole }) as ATASList[];
  let hasDocs = false;
  let hasDeletedDocs = false;
  const docNum = Object.keys(docs).length;

  if (visibleDocs.length > 0) {
    hasDocs = true;
  }

  if (hasDeleted(docs)) {
    hasDeletedDocs = true;
  }

  if (!hasDocs && !hasDeletedDocs) {
    return null;
  }

  if ((infoOnly || userAccess) && !hasDocs) {
    return null;
  }

  return (
    <Section
      id="atas"
      label={`You will need to apply for and upload an ATAS certificate`}
      canEdit={props.canResume}
      edit={() => {
        props.onResume('personal-info/step-5');
      }}
      warning={props.warning}
    >
      {visibleDocs.length > 0 ? (
        visibleDocs.map((doc: ATASList, index: number) => {
          const { key, item } = doc;

          return (
            <FingerWithApprove
              id={`${key}`}
              key={`atas-${key}-${index}`}
              status={getFingerStatus(item)}
              isProcessingPdf={item.isProcessingPdf}
              reason={item.reason}
              fileCount={item.signedUrls && item.signedUrls.length > 0 ? item.signedUrls.length : 0}
              fileNames={item.fileNames}
              label={`ATAS Certificate ${docNum > 1 ? (index > 0 ? index + 1 : '') : ''}`}
              canUpload={infoOnly ? false : props.canUpload}
              canOpen={infoOnly ? false : props.canOpen}
              canApprove={infoOnly ? false : props.canApprove}
              canReject={infoOnly ? false : props.canReject}
              isDeleting={infoOnly ? false : props.isDeleting}
              canAcknowledge={infoOnly ? props.canAcknowledge : false}
              onUploadClick={() => props.onUploadClick(key)}
              onOpenClick={() => props.onOpenClick(key)}
              onApproveClick={() => props.onApproveClick(key)}
              onRejectClick={() => props.onRejectClick(key)}
              onRescindRejectClick={() => props.onRescindRejectClick(key)}
              onDeleteClick={() => props.onDeleteClick(key)}
              onAcknowledgeClick={() => props.onAcknowledgeClick(key)}
              userRole={props.userRole}
              deletedByTTL={item.deletedByTTL}
            >
              <SummaryRow
                key={`atas-pending-${key}`}
                label="Applied for ATAS"
                fullLabel="Have you applied for your ATAS Certificate?"
                value={item.isAtasPending ? 'Yes' : 'No'}
              />
            </FingerWithApprove>
          );
        })
      ) : (
        <NoDocuments />
      )}
    </Section>
  );
};

export default ATASHand;
